import React from 'react'
import Banner from '../Menhome/Banner'

function Main() {
    return (
        <>
            <Banner />
        </>
    )
}

export default Main
